<template>
  <modal-wrapper
    @onCancelClick="$bvModal.hide('support')"
    modalId="support"
    title="Техническая поддержка"
    hide-footer
    dialogClass="support"
    @hide="clearData()"
  >
    <subtitle class="support-title" variant="v2">Отправка сообщения</subtitle>
    <form ref="supportForm" class="support-form">
      <custom-input
        inputType="text"
        placeholder="Например, Иванов Иван"
        labelText="Имя"
        v-model="name"
        :errorMessage="validationErrors['name']"
        @keydown.enter.prevent="handleFormSubmit"
        required
        name="name"
        :inputValue="name"
      />

      <custom-input
        inputType="email"
        placeholder="Введите вашу электронную почту"
        labelText="Email"
        v-model="email"
        :errorMessage="validationErrors['email']"
        @keydown.enter.prevent="handleFormSubmit"
        required
        name="email"
        :inputValue="email"
      />

      <div class="form-item">
        <label class="form-label" for="support-message">Текст обращения</label>
        <textarea
          v-model="message"
          :class="[
            'form-textarea',
            {
              'form-textarea_invalid': validationErrors['message'],
            },
          ]"
          placeholder="Введите обращение"
          name="message"
          id="support-message"
          required
        />
        <span class="error-message" v-if="validationErrors['message']">{{ validationErrors["message"] }}</span>
      </div>
    </form>
    <vue-recaptcha class="recaptcha" @verify="isCaptchaOk = true" sitekey="6Ld3XdYlAAAAAGyr4vAEcFROYWVDEtRO6boCzkcs" />

    <div class="form-checkbox-wrapper">
      <custom-checkbox color="secondary" labelText="Даю свое " v-model="approval" />
      <a class="support-link" href="https://mst.su/legal/" target="_blank">согласие на обработку персональных данных</a>
    </div>

    <div class="modal-footer-buttons">
      <main-button :loading="loading" type="button" :disabled="!isCaptchaOk || !approval" @click="sendEmail()">
        Отправить
      </main-button>
      <main-button color="link" type="button" @click="$bvModal.hide('support')">Отмена</main-button>
    </div>
  </modal-wrapper>
</template>

<script>
import Subtitle from "../ui/Subtitle.vue";
import CustomInput from "../ui/Input.vue";
import CustomCheckbox from "../ui/Checkbox.vue";
import ModalWrapper from "./ModalWrapper.vue";
import { VueRecaptcha } from "vue-recaptcha";
import MainButton from "../ui/MainButton.vue";
import { isValidEmail } from "../../utils/utils";
import emailjs from "@emailjs/browser";
import { scrollToErrorInput } from "../../utils/utils.js";

export default {
  components: { ModalWrapper, Subtitle, CustomInput, VueRecaptcha, CustomCheckbox, MainButton },
  data() {
    return {
      name: null,
      email: null,
      message: null,
      approval: false,
      isCaptchaOk: false,
      loading: false,
      validationErrors: {},
    };
  },

  methods: {
    validate() {
      this.validationErrors = {};
      const errors = {};
      let isValid = true;

      const elementNames = [
        ...Array.from(this.$refs.supportForm.elements)
          .map((element) => element.name)
          .filter((item) => Boolean(item)),
      ];
      elementNames;
      elementNames.forEach((item) => {
        if (!this[item]) {
          isValid = false;
          errors[item] = "Необходимо заполнить поле";
        }
        if (item === "email") {
          if (!isValidEmail(this[item])) {
            isValid = false;
            errors[item] = "Невалидный email";
          }
        }
      });
      scrollToErrorInput(errors, this.$refs.supportForm);
      this.validationErrors = errors;
      return isValid;
    },

    sendEmail() {
      if (!this.validate()) return;
      this.loading = true;
      emailjs.sendForm("service_kqeur3h", "template_3sl40cc", this.$refs.supportForm, "Qc5ICWt-nicfjWORw").then(
        () => {
          this.$refs.supportForm.reset();
          this.loading = false;
          this.$bvModal.hide("support");
        },
        (error) => {
          console.log("FAILED...", error.text);
          this.loading = false;
        }
      );
    },
    clearData() {
      this.name = null;
      this.email = null;
      this.message = null;
      this.approval = false;
      this.isCaptchaOk = false;
      this.loading = false;
      this.validationErrors = {};
      this.$refs.supportForm.reset();
    },
  },
};
</script>

<style scoped>
.support-title {
  margin: 0 24px 16px;
}
.support-form {
  padding: 0 24px;
}
.form-item {
  display: flex;
  flex-direction: column;
}
.form-label {
  margin-bottom: 4px;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  color: var(--black-color);
}
.form-label::after {
  content: " *";
  color: var(--error-color);
}
.form-textarea {
  min-height: 80px;
  font-family: "Inter";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: var(--black-color);
  padding: 5px 8px;
  border-radius: 3px;
  border: 1px solid var(--border-color);
  transition: border 0.15s ease-out;
}
.form-textarea::-webkit-input-placeholder {
  color: var(--grey-3-color);
}
.form-textarea::-moz-placeholder {
  color: var(--grey-3-color);
}
.form-textarea:-moz-placeholder {
  color: var(--grey-3-color);
}
.form-textarea:-ms-input-placeholder {
  color: var(--grey-3-color);
}
.form-textarea:hover,
.form-textarea:focus {
  border: 1px solid var(--primary-color);
}
.form-textarea_invalid {
  border: 1px solid var(--error-color);
}
.recaptcha {
  margin: 16px 24px;
}
.form-checkbox-wrapper {
  margin: 16px 24px;
  display: flex;
  gap: 3px;
}
.form-checkbox-wrapper .checkbox-label {
  width: max-content;
}
.support-link {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: var(--secondary-color);
}
.support-link:hover {
  color: var(--secondary-hover-color);
}
.error-message {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}
</style>
